module.exports = __webpack_public_path__ + "ff1057d672f7238e1435d123dfe7b5a5.png";